export const currentFolderScope = "tN3fuc";
export const recursiveFolderScope = "iYLled";
export const allMailboxesScope = "$DT9Se";
export const favoritesFolderScope = "vN9ucb";
export default {currentFolderScope,recursiveFolderScope,allMailboxesScope,favoritesFolderScope};